<ion-content class="bg-color padding api-catalog-view">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let list of apiCatalogList" class="breadcrumb-item">
          <a routerLink="{{list.url}}">
            {{ list.label }}
          </a>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <mat-card>
        <mat-card-title class="mc-title">
          <span class="table-header">API Catalog</span>
          <span class="total-count" *ngIf="apiCatalogDataSource.data?.length > 0">{{apiCatalogDataSource.data.length}}/{{total_records}}</span>
        </mat-card-title>
        <mat-card-content class="mc-content">
          <div class="table-container">
            <div class="filter-container">
              <div class="button-container">
                <button mat-raised-button class="add-button" routerLink='/baseapp/api-catalog/create' style="margin-right: 10px;"
                  *ngIf="catAddEnable"> Add </button>
                <!-- <button mat-raised-button class="clear-button"> Clear Search</button> -->
                <div *ngIf="bubbleshow && catAddEnable" class="box">
                  <span class="cancel-help-popup" (click)="closebubblecross()">&times;</span>
                  <p>Click "Add" button to create an API</p>
                  <button mat-raised-button style="float: right;" id="ib_list_try_out" (click)="closebubble()">Try Out</button>
                </div>
                <!-- <button class="file-upload-button">
                  
                </button> -->
                <button mat-raised-button class="add-button" style="margin-right: 10px;" *ngIf="catAddEnable && importAndExportEnableFromENV">
                  <input type="file" #fileInput (change)="onFileSelect($event)"/>
                  <mat-icon class="icon edit" matTooltip="Import API catalog" matTooltipPosition="above" *ngIf="catEditEnable"> publish </mat-icon> Import 
                </button>
                <button mat-raised-button class="add-button" style="margin-right: 10px;" *ngIf="catAddEnable && importAndExportEnableFromENV" (click)="exportCatlog()"> 
                  <mat-icon class="icon edit" matTooltip="Export API catalog"
                  matTooltipPosition="above" *ngIf="catEditEnable"> get_app </mat-icon> Export 
                </button>
              </div>
              
              <div class="search-container">
                <mat-form-field appearance="fill" class="non-fill">
                  <mat-label>Search</mat-label>
                  <input matInput type="text" placeholder="Search by brand, product, business object, type"
                    [(ngModel)]="search" (ngModelChange)="getSearchOnChange($event)">
                  <button *ngIf="search" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
            <table mat-table matTableResponsive [dataSource]="apiCatalogDataSource">
              <!-- Company Column -->
              <!-- <ng-container matColumnDef="api_source_name">
                <th mat-header-cell *matHeaderCellDef> company</th>
                <td mat-cell *matCellDef="let element">{{element.api_source_name}} </td>
              </ng-container> -->

              <!-- Product Column -->
              <ng-container matColumnDef="api_product_name">
                <th mat-header-cell *matHeaderCellDef> Product </th>
                <td mat-cell *matCellDef="let element">{{element.api_product_name.product_name}} </td>
              </ng-container>

              <!-- Brand Column -->
              <ng-container matColumnDef="api_Brand_name">
                <th mat-header-cell *matHeaderCellDef> Brand</th>
                <td mat-cell *matCellDef="let element">{{element.brand.name}} </td>
              </ng-container>

              <!-- Type Column -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef> Type </th>
                <td mat-cell *matCellDef="let element">{{element.type.name}} </td>
              </ng-container>

              <!-- Business Object Column -->
              <ng-container matColumnDef="api_business_object">
                <th mat-header-cell *matHeaderCellDef> Business Object </th>
                <td mat-cell *matCellDef="let element">{{element.api_business_object}} </td>
              </ng-container>

              <!-- Method Column -->
              <ng-container matColumnDef="method">
                <th mat-header-cell *matHeaderCellDef> Method </th>
                <td mat-cell *matCellDef="let element"> {{element.method.name}} </td>
              </ng-container>

              <!-- Import Export API -->
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox  *ngIf="importAndExportEnableFromENV" (change)="$event ? selectAllCatalog() : null"
                    [checked]="catalogselection.hasValue() && checkIsAllCatalogSelected()"
                    [indeterminate]="catalogselection.hasValue() && !checkIsAllCatalogSelected()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox *ngIf="importAndExportEnableFromENV" (click)="$event.stopPropagation()" (change)="$event ? catalogselection.toggle(row) : null"
                    [checked]="catalogselection.isSelected(row)">
                  </mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                  
                  <mat-icon class="icon edit" (click)="editCatalog(element.id)" matTooltip="Edit"
                    matTooltipPosition="above" *ngIf="catEditEnable"> edit </mat-icon>
                  <mat-icon class="icon copy" (click)="confirmCopyApiCatalog(element)" matTooltip="Copy"
                    matTooltipPosition="above"> file_copy </mat-icon>
                  <mat-icon class="icon info" (click)="catalogDetails(element.id)" matTooltip="View More"
                    matTooltipPosition="above" *ngIf="catDetailsEnable"> info </mat-icon>
                  <mat-icon class="icon delete" (click)="confirmDelete(element.id)" matTooltip="Delete"
                    matTooltipPosition="above" *ngIf="catDeleteEnable"> delete </mat-icon>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="apiCatalogdisplayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: apiCatalogdisplayedColumns;"></tr>
            </table>

            <table *ngIf="!loading">
              <tr *ngIf="!apiCatalogDataSource.data.length">
                <td style="text-align: center;" [attr.colspan]="apiCatalogdisplayedColumns.length">
                  No Records Found
                </td>
              </tr>
            </table>
          </div>
        </mat-card-content>
        <!-- <div *ngIf="total_records > 10" class="load-more-bx">
          <button mat-raised-button class="load-more" (click)="loadMore()">Load More</button>
        </div> -->
        <ion-infinite-scroll *ngIf="total_records > 10" threshold="150px" (ionInfinite)="loadMore($event)">
          <ion-infinite-scroll-content loadingSpinner="dots">
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </mat-card>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>
